"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineHeaderCSS = exports.HeaderToolbox = void 0;
var HeaderToolbox = function HeaderToolbox(Survey) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };
  var widget = {
    name: 'header',
    title: 'Text with header',
    iconName: '',
    widgetIsLoaded: function widgetIsLoaded() {
      return true;
    },
    isFit: function isFit(question) {
      return question.getType() === 'header';
    },
    init: function init() {
      Survey.Serializer.addClass('header', [{
        name: '!name',
        displayName: t('Internal Header Name'),
        category: 'general',
        visibleIndex: 0
      }, {
        name: 'title:input',
        displayName: t('Header'),
        category: 'general',
        visibleIndex: 1
      }, {
        name: 'description:input',
        displayName: t('Header Description'),
        maxLength: 160,
        category: 'general',
        visibleIndex: 2
      }, {
        name: 'visible',
        displayName: t('Is this header visible?'),
        default: true,
        category: 'general'
      }], null, 'expression');
    },
    isDefaultRender: true
  };
  Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, 'header');
};
exports.HeaderToolbox = HeaderToolbox;
var defineHeaderCSS = function defineHeaderCSS(survey) {
  survey.onUpdateQuestionCssClasses.add(function (_, options) {
    var classes = options.cssClasses;
    if (options.question.getType() === 'header') {
      classes.title = "".concat(classes.title, " header-toolbox-title");
    }
  });
};
exports.defineHeaderCSS = defineHeaderCSS;